import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export const getEtiquetas = () => {
  const fetch = async () => {
    const url = `${leadsWebEnviroment}/commom/leads/etiquetas-corretor/v1`;
    const response = await instance.get(url);
    return response?.data?.data;
  };

  const query = useQuery({
    // eslint-disable-next-line no-return-await
    queryFn: async () => await fetch(),
    queryKey: ["get-etiquetas"],
    refetchOnWindowFocus: false,
  });

  return query;
};
